import { AddressBook } from "@/features/address-book/pages/AddressBook";

export default function AddressScreen() {
  return <AddressBook />;
}
